import { render } from "./AgeCategoryForm.vue?vue&type=template&id=040e7e30&scoped=true"
import script from "./AgeCategoryForm.vue?vue&type=script&lang=js"
export * from "./AgeCategoryForm.vue?vue&type=script&lang=js"

import "./AgeCategoryForm.vue?vue&type=style&index=0&id=040e7e30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040e7e30"]])

export default __exports__